module.exports = __webpack_public_path__ + "files/6e96b03173680dcc98b687a737c3411d.jpg";